import { HttpClinet, baseURL, version } from "./../utils/config";

export const workAPI = {
  GetWork: (token, data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/getWork`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        // console.log(error+' ไอปั้นปิด Services')
        throw error;
      });
  },
  GetType: (token, params) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/type/getType`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      params,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        // console.log(error+' ไอปั้นปิด Services')
        throw error;
      });
  },
  AddWork: (token, data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/AddWork`,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  UpdateWork: (token, data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/UpdateWork`,
      method: "PATCH",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  DeleteWork: (_id) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/DeleteWork`,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      data: { _id },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  UploadCommentImage: (token, data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/UploadCommentImage`,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  GetEmail: (params) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/getEmail`,
      method: "GET",
      headers: {
        "Content-Type": "application/form-data",
      },
      params,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  SendEmail: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/SendEmail`,
      method: "POST",
      headers: {
        "Content-Type": "application/form-data",
      },
      data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  DeleteEmail: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/DeleteEmail`,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  ForceEmail: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/ForceEmail`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getWorkByID: (token, _id) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/getWorkByID/${_id}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  DownloadTemplateFile: (token, _id) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/type/DownloadTemplateFile`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: { _id },
      responseType: "blob",
    })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  },
  DownloadWorklFile: (token, name, type) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/DownloadWorklFile`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: { name, type },
      responseType: "blob",
    })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  },
  checkFileSecond: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/checkFileSecond`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  assistWork: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/assistWork`,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  reportByType: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/reportByType`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    })
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  reportByWork: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/reportByWork`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    })
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  ExportExcelbyType: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/ExportExcelbyType`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
      responseType: "blob",
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw error;
      });
  },
  ExportExceloneOnone: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/ExportExceloneOnone`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
      responseType: "blob",
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw error;
      });
  },
  updatePin: (_id) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/work/updatePin`,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      data: { _id },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
};
